import { Libraries } from "@react-google-maps/api";

export const GOOGLE_MAPS_LIBRARIES: Libraries = [
  "drawing",
  "places",
  "maps",
  "geometry",
  "marker",
];

export const GOOGLE_MAPS_OPTIONS = {
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};

// Central default coordinates (Santa Tecla, El Salvador)
export const DEFAULT_COORDS = { lat: 13.6731, lng: -89.2797 };

// Default coordinates per country short code
export const DEFAULT_COORDS_BY_COUNTRY: Record<
  string,
  { lat: number; lng: number }
> = {
  SLV: { lat: 13.6929, lng: -89.2182 },
  GTM: { lat: 14.533328, lng: -90.596432 },
};

export function getDefaultCoordsForCountry(shortName?: string) {
  if (!shortName) return DEFAULT_COORDS;
  return DEFAULT_COORDS_BY_COUNTRY[shortName] || DEFAULT_COORDS;
}
